import RichMarker from 'libs/richmarker';
import Backbone from 'backbone';

const MAX_ICONS = 3;
export default Backbone.View.extend({

  template: require('./routeLabels.hbs'),

  constructor(options) {
    this.labels = [];
    this.widget = options.widget;
    this.map = this.widget.map;
    this.totalTime = 0;
    this.totalDistanceMeters = 0;
    this.minZoom = 11;
    this.zoomControl = options.config.zoomControl;
    if (this.zoomControl) {
      this._addListener();
    }
  },

  _addListener() {
    google.maps.event.addListener(this.map, 'zoom_changed', () => {
      this.evaluateZoom();
    });
  },

  evaluateZoom() {
    if (this.zoomControl && (this.map.getZoom() < this.minZoom)) {
      this.hideLabels();
    } else {
      if (this.route) {
        this.showLabels();
      }
    }
  },

  createLabel(route) {
    this.route = route;
    let optRoute = route.optRoute;
    this.templateConfig = this._parseData(route.providedRoute);
    let resultantPath = {
      path: [],
      options: optRoute[0].options //get the first because all be equals
    };
    optRoute.forEach(opt => {
      resultantPath.path.push(...opt.path);
    });
    resultantPath.dataDistance = this._calculateDistances(resultantPath.path);
    this.label = this._addLabel(resultantPath, this.map);
  },

  _addLabel(opt, map) {
    let pos, label, middlePosition = this._calculatePosition(opt.path, opt.dataDistance);
    pos = middlePosition;
    this.templateConfig = Object.assign({
      direction: pos.direction
    }, this.templateConfig);

    this.render();
    let labelContent = this.$el[0];
    label = new RichMarker.RichMarker({
      position: pos.position,
      content: labelContent,
      flat: true,
      anchor: RichMarker.RichMarkerPosition[pos.direction.markerPosition],
      height: '15px',
      draggable: false,
      map: this.map
    });
    label.setZIndex(1000);
    this.labels.push(label);
    this.evaluateZoom();
    return label;
  },

  _calculateDistances(path) {
    let i;
    let distances = [];
    let distance;
    let distancesObject = {};
    let totalDistance = 0;
    for (i = 1; i < path.length; i++) {
      distance = google.maps.geometry.spherical.computeDistanceBetween(path[i - 1], path[i]);
      distances.push(distance);
      distancesObject[distance] = i;
      totalDistance += distance;
    }
    return {
      distancesForSteps: distances,
      distancesObject: distancesObject,
      totalDistance: totalDistance
    };
  },

  _calculatePosition(path, dataDistance) {
    let posiblePositions;
    posiblePositions = this._getPosiblePositions(dataDistance.distancesForSteps, dataDistance.distancesObject, path);
    let newGroups = {};
    let nameAux = '';
    posiblePositions.forEach((pos, index, allPos) => {
      if (index === 0 ||
        (index > 0 && pos.direction.arrow !== allPos[index - 1].direction.arrow)) {
        nameAux = `${pos.direction.arrow}-${index}`;
        newGroups[nameAux] = [];
        newGroups[nameAux].push(pos);
      }
      newGroups[nameAux].push(pos);
    });
    let newGroupsValues = Object.keys(newGroups).map(key => newGroups[key]);
    let max = newGroupsValues
      .reduce((prev, current) => (prev.length > current.length) ? prev : current);
    let middlePosition = max[Math.floor(max.length / 2)];
    return middlePosition;
  },

  _getPosiblePositions(distances, distancesObject, path) {
    let posiblePositions = [];
    let i;
    let index;
    let start;
    let end;
    let midpoint;

    for (i = 0; i < distances.length; i++) {
      index = distances[i];
      start = path[distancesObject[index] - 1];
      end = path[distancesObject[index]];
      midpoint = this._getMidpoint(start, end);
      posiblePositions.push({
        position: midpoint,
        direction: this._getDirectionPosition(start, end)
      });
    }
    return posiblePositions;
  },

  _getMidpoint(start, end) {
    return google.maps.geometry.spherical.interpolate(start, end, 0.5);
  },

  _sortNumber(a, b) {
    return a - b;
  },

  _getDirectionPosition(start, end) {
    let arrow;
    let markerPosition;
    let angle = google.maps.geometry.spherical.computeHeading(start, end);
    if (angle > 0 && angle <= 45) {
      arrow = 'left';
      markerPosition = 'TOP_LEFT';
    } else if (angle > 45 && angle <= 90) {
      arrow = 'up-left';
      markerPosition = 'TOP_LEFT';
    } else if (angle > 90 && angle <= 135) {
      arrow = 'down-left';
      markerPosition = 'BOTTOM_LEFT';
    } else if (angle > 135) {
      arrow = 'left';
      markerPosition = 'BOTTOM_LEFT';
    } else if (angle < 0 && angle >= -45) {
      arrow = 'right';
      markerPosition = 'TOP_RIGHT';
    } else if (angle < -45 && angle >= -90) {
      arrow = 'up-right';
      markerPosition = 'TOP_RIGHT';
    } else if (angle < -90 && angle >= -135) {
      arrow = 'down-right';
      markerPosition = 'BOTTOM_RIGHT';
    } else if (angle < -135) {
      arrow = 'right';
      markerPosition = 'BOTTOM_RIGHT';
    }

    return {
      arrow: arrow,
      markerPosition: markerPosition
    };
  },

  removeLabels() {
    this.labels.forEach(label => {
      label.setMap(null);
    });
    this.labels = [];
  },

  hideLabels() {
    this.labels.forEach(label => {
      label.setMap(null);
    });
  },

  showLabels() {
    this.labels.forEach(label => {
      label.setMap(this.map);
    });
  },

  render() {
    this.setElement(this.template(this.templateConfig));
    return this;
  },

  _parseData(route) {
    let travelModeIcons = this._parseDataTransportIconds(route);
    return {
      distance: route.legs[0].distance.text,
      totalTimeFormatedString: route.legs[0].duration.text,
      travelModeIcons: travelModeIcons,
      onlyOneIcon: travelModeIcons.length === 1
    };
  },

  _parseDataTransportIconds(route) {
    let steps = route.legs[0].steps;
    let TRAVEL_MODE = 'travel_mode';
    let travelmodes = [];
    let stepsLength = steps.length;
    let firstTransitValue = steps[0][TRAVEL_MODE];
    let isTheSameTransitValue = steps.every(element => { return element[TRAVEL_MODE] === firstTransitValue; });
    if (isTheSameTransitValue) {
      travelmodes.push(`lmm-icon-${steps[0][TRAVEL_MODE].toLowerCase()}`);
    } else {
      for (let i = 0; i < stepsLength; i++) {
        if ((i < MAX_ICONS - 1) || (i === stepsLength - 1)) {
          travelmodes.push(`lmm-icon-${steps[i][TRAVEL_MODE].toLowerCase()}`);
        } else {
          travelmodes.push(`lmm-md-icon-dots`);
          travelmodes.push(`lmm-icon-${steps[stepsLength - 1][TRAVEL_MODE].toLowerCase()}`);
          return travelmodes;
        }
      }
    }
    return travelmodes;
  }
});



// WEBPACK FOOTER //
// ./lmm-widget/src/views/routeLabels/RouteLabels.js